
// client/src/pages/ContactPage.js
import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import ContactForm from "../components/ContactForm";
import SeoMeta from "../components/SeoMeta";
import "../styles/ContactPage.css";
import "../styles/ContactCard.css";
import "../styles/PageHero.css";

function ContactPage() {
  return (
    <div className="contact-page">
      <SeoMeta
        title="Contact Ziyad Attorneys | Addis Ababa, Ethiopia"
        description="Contact Ziyad Attorneys in Addis Ababa, Ethiopia, to enquire about legal representation and our services. Find our office details and business hours."
      />
      {/* Hero Section */}

    <div
      className="about-hero page-photo-hero"

      style={{ backgroundImage: "url(/o1p.png)" }}
    >

      <h1 className="page-header-title page-hero-title page-hero-lower-title">
        Contact <span className="highlight">Us</span>
      </h1>

    </div>

      {/* Intro Section */}
      <Container className="my-5 text-center">
        <h2 className="section-title">We’re Here to Help</h2>
        <p className="contact-intro">
          Whether you need legal guidance, representation, or simply want to
          learn more about our services, our team is here to support you.
          Connect with us through the channels below.
        </p>
      </Container>

      {/* Contact Info + Form */}
      <Container className="my-5 contact-section">
        <Row>
          <Col md={5} className="mb-4 mb-md-0">
            <Card className="h-100 shadow-sm professional-card contact-card contact-info-card">
              <Card.Body>
                <Card.Title>Contact Information</Card.Title>
                <div className="contact-item">
                  <i className="fas fa-map-marker-alt"></i>
                  <span>Addis Ababa, Ethiopia</span>
                </div>
                
                <div className="contact-item">
                  <i className="fas fa-phone"></i>
                  <span className="contact-phone-number">
                    <a href="tel:+251913811743">+251-913-81-17-43</a>
                    {' / '}
                    <a href="tel:+251930750575">+251-930-75-05-75</a>
                  </span>
                </div>

                <div className="contact-item">
                  <i className="fas fa-envelope"></i>
                  <a href="mailto:ziyadlawoffice@gmail.com">
                    ziyadlawoffice@gmail.com
                  </a>
                </div>

                <div className="business-hours mt-4">
                  <Card.Title>Business Hours</Card.Title>
                  <p>Monday – Friday: 8:30 AM – 5:30 PM</p>
                  <p>Saturday: 9:00 AM – 1:00 PM</p>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={7}>
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <h4 className="mb-4">Send Us a Message</h4>
                <ContactForm />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Location Section */}
      <Container className="my-5 location-section text-center">
        <h2 className="section-title">Our Location</h2>
        <div className="map-wrapper">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.6172884450602!2d38.71627910948994!3d9.00731778929289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b85cef5ab402d%3A0x4ab1b61f8cd4199c!2s2P49%2BWGH%2C%20Addis%20Ababa%2C%20Ethiopia!5e0!3m2!1sen!2sse!4v1754667596642!5m2!1sen!2sse"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Ziyad Attorneys Location"
          ></iframe>
        </div>
      </Container>
    </div>
  );
}

export default ContactPage;
